import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { setAdminKey, eosApi } from "../../lib/eosApi";
import { useDocMeta } from "../../lib/useDocMeta";

// EOS access gate — collects the founder ADMIN_KEY and validates it against
// GET /api/eos/meta before persisting. Redirects to /eos/inbox on success.
export default function EosGate() {
  useDocMeta({ title: "EOS · Founder Workspace", path: "/eos" });
  const nav = useNavigate();
  const [key, setKey] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!key.trim()) return;
    setBusy(true);
    setAdminKey(key.trim());
    try {
      await eosApi().get("/meta");
      toast.success("Founder Workspace unlocked");
      nav("/eos/inbox");
    } catch (err) {
      toast.error(err?.response?.status === 401 ? "Invalid admin key" : "Failed to unlock");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="eos-gate">
      <form onSubmit={submit} className="w-full max-w-md bg-[var(--bg-secondary)] border border-[var(--border-soft)] p-8 space-y-5">
        <div>
          <div className="tick-label text-sky-400 mb-1">/ Founder Workspace</div>
          <h1 className="font-display font-black text-3xl text-slate-100 leading-tight">Enter admin key</h1>
          <p className="text-slate-400 text-sm mt-2">
            The EOS Founder Workspace is restricted to authorized personnel. Enter your admin key to continue.
          </p>
        </div>
        <label className="block">
          <span className="tick-label mb-1.5 inline-block">Admin Key</span>
          <input
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="••••••••••••"
            data-testid="eos-gate-key-input"
            className="w-full bg-[var(--bg-primary)] border border-[var(--border-soft)] focus:border-sky-500/70 outline-none text-slate-100 text-sm px-3 py-2 font-mono"
            autoFocus
          />
        </label>
        <button
          disabled={busy}
          type="submit"
          data-testid="eos-gate-submit"
          className="w-full inline-flex items-center justify-center gap-2 bg-sky-500 hover:bg-sky-400 disabled:opacity-40 text-slate-950 font-mono text-[11px] tracking-[0.2em] uppercase font-bold px-4 py-2.5"
        >
          {busy ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Verifying…</> : <><ShieldCheck className="w-3.5 h-3.5" /> Unlock Workspace</>}
        </button>
      </form>
    </div>
  );
}
